import * as React from "react";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { Outlet } from "react-router-dom";
import { PageContainer } from "@toolpad/core";
import PreventBackNavigation from "../../hooks/usePreventBackNavigation";
import HeaderSectionProvider from "./HeaderSection/HeaderSectionProvider";

const DashboardProvider = () => {
  const breadcrumbs = [{ title: "", path: "" }];
  return (
    <DashboardLayout>
      <PreventBackNavigation />
      <HeaderSectionProvider />
      <PageContainer
        breadcrumbs={breadcrumbs}
        title=""
        style={{
          maxWidth: "100%",
          margin: 0,
          padding: 5,
        }}
      >
        <Outlet />
      </PageContainer>
    </DashboardLayout>
  );
};

export default DashboardProvider;
